import { routes } from "@const/routes";
import { EAppAction } from "@store/appReducer";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  faBars,
  faGaugeHigh,
  faKey,
  faUserFriends,
  faGamepad,
  faTicketAlt,
  faTrophy,
  faGift,
  faTicket,
  faDiamondTurnRight
} from "@fortawesome/free-solid-svg-icons";


const useDataSideBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state: RootState) => state.auth.token);
  const onOpenReferPopup = () => {
    if (!isLoggedIn) {
      navigate("/login");
      return;
    }
    dispatch({
      type: EAppAction.SHOW_REFER_POPUP,
      payload: true,
    });
  };

  const DataSideDashboardBar = [
    // {
    //   id: 5,
    //   title: "Home",
    //   link: routes.landing,
    //   logo: faBars,
    // },
    {
      id: 1,
      title: "Dashboard",
      link: routes.dashboard,
      logo: faBars,
      hasDropdown: true,
      dropdownItems: [
        {
          id: 1,
          title: "Games Lobby",
          link: routes.dashboard,
          logo: faGamepad,
        },
        // {
        //   id: 12,
        //   title: "My Raffles",
        //   link: routes.raffle,
        //   logo: faGift,
        // },
        {
          id: 2,
          title: "My Tickets",
          link: routes.ticket,
          logo: faTicketAlt,
        },
        {
          id: 3,
          title: "Results",
          link: routes.raffleResult,
          logo: faTrophy,
        },
      ],
    },
    // {
    //   id: 2,
    //   title: "Refer a friend",
    //   link: "",
    //   logo: faUserFriends,
    //   otherAction: onOpenReferPopup,
    // },
    {
      id: 3,
      title: "Ticket Zone",
      link: routes.ticketGenerator,
      logo: faTicket,
    },
    {
      id: 4,
      title: "Contact Us",
      link: routes.contact,
      logo: faUserFriends,
    },
    // { id: 5, title: "Go to Daburshop", link: "www.daburshop.com", logo: faDiamondTurnRight },
  ];

  return {
    DataSideDashboardBar,
  };
};

export default useDataSideBar;
